<template>
    <section>
        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>  
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm">
                <div class="material-box bg-white p-2">
                    <div class="row content-row ">
                        <div class="col-md-12 ">
                            <div class="content-colm row">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-8 col-sm-8">
                                            <div class="scottnotes">Scott Notes contain the most important Materials in a given Module, and are exclusive to their respective Module.</div>
                                        </div>
                                        <div class="col-md-4 col-sm-4 skill_img">
                                               <img src="./../../assets/images/good-img.png" alt="" class="pull-right">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 top-title">
                                    <div class="skill-set">
                                        <div class="skill-btn archieve-btn f-archieve-btn" v-for="(item,i) in modules" :key="i">
                                            <router-link :to="{name:'scott_notes_material',params:{id:item.ModuleID}}">Module {{ item.ModuleNumber }} - {{item.ModuleName}}</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment'
// import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "ScottNotes",
    data() {
        return {
            isLoading: false,
            modules: {}
        }
    },
    methods: {
        getAllModules() {
            this.isLoading = true;
            userAPI.getAllModules(res => {
                this.modules = res.data.data
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        }
    },
    mounted() {
        this.getAllModules();
    },
    components: {
        Sidebar
    }
}
</script>

<style>
.f-archieve-btn > a:before {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.f-archieve-btn {
    width: 50% !important;
}

@media only screen and (max-width: 575px) {
    .skill_img {
        text-align: center;
    }
    .skill_img img {
        width: auto !important;
        float: none;
    }
    .scottnotes {
        margin-top: 10px;
    }
}

@media only screen and (max-width: 420px) {
    .f-archieve-btn {
        width: 100% !important;
    }
}
</style>